import de from "../i18n/de.json";
import en from "../i18n/en.json";
import es from "../i18n/es.json";
import fr from "../i18n/fr.json";
import itMessages from "../i18n/it.json";

export const SUPPORTED_LOCALES = ["en", "de", "fr", "es", "it"];
export const DEFAULT_LOCALE = "en";

const MESSAGES = { de, en, es, fr, it: itMessages };

const INTL_DATE_LOCALES = {
  en: "en-GB",
  de: "de-DE",
  fr: "fr-FR",
  es: "es-ES",
  it: "it-IT"
};

export function normalizeLocale(locale) {
  const code = (locale || DEFAULT_LOCALE).toString().toLowerCase().split("-")[0];
  return SUPPORTED_LOCALES.includes(code) ? code : DEFAULT_LOCALE;
}

export function getPortalLocale() {
  const raw =
    (typeof navigator !== "undefined" && navigator.language) ||
    (typeof document !== "undefined" && document.documentElement.lang) ||
    DEFAULT_LOCALE;
  return normalizeLocale(raw);
}

export function intlDateLocale(locale) {
  const code = normalizeLocale(locale);
  return INTL_DATE_LOCALES[code] || INTL_DATE_LOCALES.en;
}

export function createTranslator(locale = DEFAULT_LOCALE) {
  const lang = normalizeLocale(locale);
  const catalog = MESSAGES[lang] || MESSAGES.en;

  return function t(key, vars = {}) {
    const parts = key.split(".");
    let value = catalog;
    for (const part of parts) {
      value = value?.[part];
    }
    if (typeof value !== "string") {
      const fallback = MESSAGES.en;
      let enValue = fallback;
      for (const part of parts) {
        enValue = enValue?.[part];
      }
      if (typeof enValue !== "string") return key;
      value = enValue;
    }

    return Object.entries(vars).reduce(
      (text, [name, replacement]) => text.replace(`{${name}}`, String(replacement)),
      value
    );
  };
}
